export default {
    cars: [{
            name: "ZFR 1.0",
            image: "zfr1.jpg",
            Specifications: [{
                    name: "Chassis ",
                    value: "Tubular Space Frame (Mild Steel round)"
                },
                {
                    name: "Power",
                    value: "22.11 BHP @9300 rpm"
                },
                {
                    name: "Weight",
                    value: "301 kg"
                },
                {
                    name: "Bodyworks",
                    value: "FRP"
                },
                {
                    name: "Engine",
                    value: "250cc, Honda CBR 250R"
                },
                {
                    name: "Tyres",
                    value: "13 YOKOHAMA High Performance Tyres"
                },
                {
                    name: "Wiring",
                    value: "Standard Wiring"
                },
                {
                    name: "ECU",
                    value: "Stock ECU"
                },
                {
                    name: "Suspension",
                    value: "Double Wishbone unequal length push rod actuated"
                },
                {
                    name: "Cooling",
                    value: "Stock Cooling System"
                }
            ],
            Team: [{
                "designation": "Mechanical",
                "name": "Abhishek Pathak"
            }, {
                "designation": "Mechanical",
                "name": "Meraj Ahmad"
            }, {
                "designation": "Mechanical",
                "name": "Shashank Gupta"
            }, {
                "designation": "Mechanical",
                "name": "Prashant Singh"
            }, {
                "designation": "Mechanical",
                "name": "Ishan Sharma"
            }, {
                "designation": "Mechanical",
                "name": "Pushkin Mittal"
            }, {
                "designation": "Mechanical",
                "name": "Prasenjit Tomar"
            }, {
                "designation": "Mechanical",
                "name": "Kushagra Kumar"
            }, {
                "designation": "Mechanical",
                "name": "Rahul Sharma"
            }, {
                "designation": "Electronics",
                "name": "Himank Gulati"
            }, {
                "designation": "Electronics",
                "name": "Sahil Abbas Zaidi"
            }, {
                "designation": "Mechanical",
                "name": "Chandresh Gandhi"
            }, {
                "designation": "Mechanical",
                "name": "Prateek Goyal"
            }, {
                "designation": "Electronics",
                "name": "Tushar Singhal"
            }, {
                "designation": "Mechanical",
                "name": "Mehul Varshney"
            }, {
                "designation": "Mechanical",
                "name": "Mohd. Afzal Shadab"
            }, {
                "designation": "Mechanical",
                "name": "Arpit Upadhyay"
            }, {
                "designation": "Mechanical",
                "name": "Ayush Mittal"
            }, {
                "designation": "Mechanical",
                "name": "Irfan Khan"
            }]
        },
        {
            name: "ZFR 2.0",
            image: "zfr2.jpg",
            Specifications: [{
                "name": "Chassis ",
                "value": "Tubular Space Frame (AISI-4130 Steel round)"
            }, {
                "name": "Power",
                "value": "22.11 BHP @9300 rpm"
            }, {
                "name": "Weight",
                "value": "301 kg"
            }, {
                "name": "Bodyworks",
                "value": "GFRP"
            }, {
                "name": "Engine",
                "value": "250cc, Honda CBR 250R"
            }, {
                "name": "Tyres",
                "value": "13\" YOKOHAMA High Performance Tyres"
            }, {
                "name": "Wiring",
                "value": "Standard Wiring"
            }, {
                "name": "ECU",
                "value": "Stock ECU"
            }, {
                "name": "Suspension",
                "value": "Double Wishbone unequal length push rod actuated"
            }, {
                "name": "Cooling",
                "value": "Stock Cooling System"
            }],
            Team: [{
                "designation": "Team Captain:",
                "name": "Arpit upadhyaya"
            }, {
                "designation": "Vehicle Dynamics Lead:",
                "name": "Mohammad Faraz"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Faizan Anwar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Aasim Noor"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Aayush Mittal"
            }, {
                "designation": "Chassis Lead:",
                "name": "Irfan Ahmed"
            }, {
                "designation": "Chassis team member:",
                "name": "Wamiq Hashmi"
            }, {
                "designation": "Chassis team member:",
                "name": "Areeb Mahmood"
            }, {
                "designation": "Power Train Lead:",
                "name": "Anchal Varshney"
            }, {
                "designation": "Power Train team member:",
                "name": "Mehul Varshney"
            }, {
                "designation": "Power Train team member:",
                "name": "Arpit upadhyaya"
            }, {
                "designation": "Power Train team member:",
                "name": "Mridul"
            }, {
                "designation": "Power Train team member:",
                "name": "Hamza Khan"
            }, {
                "designation": "Electronics Lead:",
                "name": "Hamza"
            }, {
                "designation": "Electronics team member:",
                "name": "Subham Varshney"
            }, {
                "designation": "Team Manager:",
                "name": "Aman Agarwal"
            }, {
                "designation": "Team Captain:  ",
                "name": "Arpit upadhyaya"
            }]
        },
        {
            name: "ZFR 3.0",
            image: "zfr3.jpg",
            Specifications: [{
                "name": "Chassis",
                "value": "Tubular Space Frame (AISI-4130 Steel round)"
            }, {
                "name": "Power",
                "value": "22.11 BHP @9300 rpm"
            }, {
                "name": "Weight",
                "value": "190 kg"
            }, {
                "name": "Bodyworks",
                "value": "CFRP"
            }, {
                "name": "Engine",
                "value": "250cc, Honda CBR 250R(2014 Model)"
            }, {
                "name": "Tyres",
                "value": "10” Hoosier Formula Spec Tyres"
            }, {
                "name": "Wiring",
                "value": "Custom Built Wiring Harness"
            }, {
                "name": "ECU",
                "value": "Stock ECU with BAZZAZ"
            }, {
                "name": "Suspension",
                "value": "Double Wishbone unequal length pull and push rod actuated"
            }, {
                "name": "Cooling",
                "value": "Self Designed and Fabricated Cooling System"
            }],
            Team: [{
                "designation": "Team Captain:  ",
                "name": "Arpit upadhyaya"
            }, {
                "designation": "Vehicle Dynamics Lead:",
                "name": "Mohammad Faraz"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Faizan Anwar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Aasim Noor"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Aayush Mittal"
            }, {
                "designation": "Chassis Lead:",
                "name": "Irfan Ahmed"
            }, {
                "designation": "Chassis team member:",
                "name": "Wamiq Hashmi"
            }, {
                "designation": "Chassis team member:",
                "name": "Areeb Mahmood"
            }, {
                "designation": "Power Train Lead:",
                "name": "Anchal Varshney"
            }, {
                "designation": "Power Train team member:",
                "name": "Mehul Varshney"
            }, {
                "designation": "Power Train team member:",
                "name": "Arpit upadhyaya"
            }, {
                "designation": "Power Train team member:",
                "name": "Mridul"
            }, {
                "designation": "Power Train team member:",
                "name": "Hamza Khan"
            }, {
                "designation": "Electronics Lead:",
                "name": "Hamza"
            }, {
                "designation": "Electronics team member:",
                "name": "Subham Varshney"
            }, {
                "designation": "Team Manager:",
                "name": "Aman Agarwal"
            }, {
                "designation": "Team Captain:  ",
                "name": "Arpit upadhyaya"
            }]
        },
        {
            name: "ZFR 4.0",
            image: "zfr4.jpg",
            Specifications: [{
                "name": "Chassis",
                "value": "Tubular Space Frame (AISI-4130 Steel round)"
            }, {
                "name": "Power",
                "value": "22.11 BHP @9300 rpm"
            }, {
                "name": "Weight",
                "value": "208 kg"
            }, {
                "name": "Bodyworks",
                "value": "GFRP"
            }, {
                "name": "Engine",
                "value": "250cc, Honda CBR 250R (2014 Model)"
            }, {
                "name": "Tyres",
                "value": "10” Hoosier Formula Spec Tyres"
            }, {
                "name": "Wiring",
                "value": "Custom Built Wiring Harness"
            }, {
                "name": "ECU",
                "value": "Stock ECU with BAZZAZ"
            }, {
                "name": "Suspension",
                "value": "Double Wishbone unequal length pull and push rod actuated"
            }, {
                "name": "Cooling",
                "value": "Self Designed and Fabricated Cooling System"
            }],
            Team: [{
                "designation": "Team Captain:",
                "name": "Shubham Varshney"
            }, {
                "designation": "Vehicle Dynamics Lead:",
                "name": "Faizan Anwar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Mohd Tashif"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Saad Khan"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Syed Nasir Ashgar"
            }, {
                "designation": "Chassis Lead:",
                "name": "Wamiq Hashmi"
            }, {
                "designation": "Chassis team member:",
                "name": "Qazi Mohammad Taha"
            }, {
                "designation": "Chassis team member:",
                "name": "Rohit Shareshwat"
            }, {
                "designation": "Power Train Lead:",
                "name": "Areeb Mahmood"
            }, {
                "designation": "Power Train team member:",
                "name": "Nafees Ahmad"
            }, {
                "designation": "Power Train team member:",
                "name": "Nakul Varshney"
            }, {
                "designation": "Electronics Lead:",
                "name": "Shubham Varshney"
            }, {
                "designation": "Electronics team member:",
                "name": "Prashant Varshant Singh"
            }, {
                "designation": "Electronics team member:",
                "name": "Anurita Verwal"
            }, {
                "designation": "Electronics team member:",
                "name": "Shadman Faraz"
            }, {
                "designation": "Electronics team member:",
                "name": "Shivam Upadhyaya"
            }, {
                "designation": "Electronics team member:",
                "name": "Asadullah Khan"
            }, {
                "designation": "Team Manager:",
                "name": "Kamran Shakir"
            }, {
                "designation": "Management Team Member:",
                "name": "Syed Ali Zaheen"
            }, {
                "designation": "Management Team Member:",
                "name": "Rishabh"
            }]
        },
        {
            name: "ZFR 4.1",
            image: "zfr4.1.jpg",
            Specifications: [],
            Team: [{
                "designation": "Team Captain:",
                "name": "Sarif Anwar"
            }, {
                "designation": "Vehicle Dynamics Lead:",
                "name": "Mohd Tashif"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Syed Nasir Ashgar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Rehan Abad Siddiqui"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Yogesh Kumar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Hina Tomar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Waris Khan"
            }, {
                "designation": "Chassis Lead:",
                "name": "Rishabh"
            }, {
                "designation": "Chassis team member:",
                "name": "Himanshu Verma"
            }, {
                "designation": "Power Train Lead:",
                "name": "Nafees Ahmad"
            }, {
                "designation": "Power Train team member:",
                "name": "Pradeep Kumar"
            }, {
                "designation": "Power Train team member:",
                "name": "Suboor Aziz"
            }, {
                "designation": "Electronics Lead:",
                "name": "Shivam Upadhyaya"
            }, {
                "designation": "Electronics team member:",
                "name": "Pakhil\n                                                "
            }, {
                "designation": "Electronics team member:",
                "name": "Mohit Kumar"
            }, {
                "designation": "Team Manager:",
                "name": "Qazi Mohammad Taha"
            }, {
                "designation": "Management Team Member:",
                "name": "Burhan Shamsi"
            }]
        },
        {
            name: "ZFR 5.0",
            image: "zfr5.jpg",
            Specifications: [{
                "name": "Chassis",
                "value": "Tabular Space Frame (AISI-4130 Steel round)"
            }, {
                "name": "Power",
                "value": "22.11 BHP @9300 rpm"
            }, {
                "name": "Weight",
                "value": "175 kg"
            }, {
                "name": "Bodyworks",
                "value": "CFRP"
            }, {
                "name": "Engine",
                "value": "390cc, KTM 390 (2017 Model)"
            }, {
                "name": "Tyres",
                "value": "10” Hoosier Formula Spec Tyres"
            }, {
                "name": "Wiring",
                "value": "Custom Built Wiring Harness"
            }, {
                "name": "ECU",
                "value": "Stock ECU"
            }, {
                "name": "Suspension",
                "value": "Double Wishbone unequal length pull and push rod actuated"
            }, {
                "name": "Cooling",
                "value": "Self Designed and Fabricated Cooling System"
            }],
            Team: [{
                "designation": "Team Captain:",
                "name": "Sarif Anwar"
            }, {
                "designation": "Vehicle Dynamics Lead:",
                "name": "Mohd Tashif"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Sarif Anwar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Rehan Abad Siddiqui"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Yogesh Kumar"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Burhan Shamsi"
            }, {
                "designation": "Vehicle Dynamics team member:",
                "name": "Waris Khan"
            }, {
                "designation": "Chassis Lead:",
                "name": "Qazi Mohd Taha"
            }, {
                "designation": "Chassis team member:",
                "name": "Tazeem Khan"
            }, {
                "designation": "Power Train Lead:",
                "name": "Mohd Suboor Aziz"
            }, {
                "designation": "Power Train team member:",
                "name": "Swarnima Chaudhary"
            }, {
                "designation": "Power Train team member:",
                "name": "Mohd Atif Qazi"
            }, {
                "designation": "Electronics Lead:",
                "name": "Mohit Mangal"
            }, {
                "designation": "Electronics team member:",
                "name": "Hina Tomar"
            }, {
                "designation": "Electronics team member:",
                "name": "Kunal Sharma"
            }, {
                "designation": "Team Manager:",
                "name": "Qazi Mohd Taha"
            }, {
                "designation": "Management Team Member:",
                "name": "Burhan Shamsi"
            }, {
                "designation": "Management Team Member:",
                "name": "Arsalan Sartaj"
            }, {
                "designation": "Management Team Member:",
                "name": "Meesum Raza Zaidi"
            }, {
                "designation": "Management Team Member:",
                "name": "Vinayak Varshney"
            }, {
                "designation": "Management Team Member:",
                "name": "Imad Uddin"
            }]
        }
    ]
}